import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MatBottomSheetRef } from "@angular/material";

@Component({
  selector: "ya-invalidDeliveryAddress",
  templateUrl: "./invalidDeliveryAddress.component.html",
  styleUrls: ["./invalidDeliveryAddress.component.scss"]
})
export class InvalidDeliveryAddressComponent implements OnInit {

  constructor(private _router: Router
    , public bottomSheetRef: MatBottomSheetRef<InvalidDeliveryAddressComponent>) { }

  ngOnInit() {
  }

  public onChangeLocation() {
    const me = this;
    me._router.navigate(["/menulocation"]);
    me.bottomSheetRef.dismiss();
  }

  public onChangeService() {
    const me = this;
    me._router.navigate(["/menuservice"]);
    me.bottomSheetRef.dismiss();
  }
}
